import React, { useState, useEffect } from "react"; 
import FadeLoader from "react-spinners/FadeLoader";
import Divider from '@mui/material/Divider';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import './Pricing.css';
import AddNewPricing from "./AddNewPricing";
import { FcCancel } from "react-icons/fc";
import ValidationMessages from "../utils/validationMessages"
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const Pricing=()=> {
    const [rowsData, setRowsData] = useState([]);
    const [isPricingPopupOpen, setIsPricingPopupOpen] = useState(false);
    const [pricingData, setPricingData] = useState(rowsData);
    const [editPopup, setEditPopup] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [updateData, setUpdateData] = useState([]);
    const [, setPopupVisible] = useState(false);

    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const dayMap = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday"
    };

    const formatTime = (timeString) => {
    const [hours, minutes] = timeString.split(":");
    const date = new Date();
    date.setHours(parseInt(hours), parseInt(minutes));
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const fetchPricingPlans = async () => {
        try {
            const response = await fetch(`${hostPath}/api/GetAllPricingPlans`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "x-functions-key": `${hostHeader}`
                },
             
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            const formattedData = data.map(item => ({
                id: item.id,
                pricingPlanID: item.pricingPlanID,
                pricingPlanName: item.pricingPlanName,
                occurrence: item.occurrence,
                price: item.price,
                rateUnit: item.rateUnit,
                location: item.location,
                timeRanges: item.timeRanges,
                isDefault:item.isDefault,
                status:item.status,
                createdDate: item.createdDate,
                lastUpdatedDate: item.lastUpdatedDate
                }));
            setRowsData(formattedData);
        }
         catch (error) {
            setLoader(false);
            console.error("Error fetching pricing plans:", error);
        }
        finally {
            setLoader(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        setLoader(true);
        fetchPricingPlans();
    }, [updateData]);

    const handleNewPricingPlan = () => {
        setIsPricingPopupOpen(true);
        setEditPopup(false);
        setPricingData(null);
    }
    const handleCancelPricing = () => {
        setIsPricingPopupOpen(false);
        setEditPopup(false)
    }
    const handleEdit = (row) => {
        setIsPricingPopupOpen(true);
        setEditPopup(true);
        setPricingData(row)
    }
    const handleSaveSuccess = () => {
    fetchPricingPlans();  // Reload list
    setIsPricingPopupOpen(false);
    };

    // const handleDelete = async (row) => {
    //     setLoader(true);
    //     const rowID = row.id;
    //     try {
    //         const response = await fetch(`${hostPath}/api/DeletePricingPlan`, {
    //             method: "DELETE",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "x-functions-key": `${hostHeader}`
    //             },
    //             body: JSON.stringify({ id: rowID })
    //         });

    //         if (!response.ok) {
    //             throw new Error(`HTTP error! Status: ${response.status}`);
    //         }
    //         fetchPricingPlans();
    //     } catch (error) {
    //         console.error("Error deleting pricing plan:", error);
    //     }
    // };
    const handleDelete = (val, typeOfButton) => {
        let message;
        let message2;
        let status;
        if (typeOfButton === 'trash') {
            message = ValidationMessages.deletePricing;
            message2 = ValidationMessages.proceed
            status = 'delete';
        } else if (typeOfButton === 'cancel') {
            message = ValidationMessages.pricingInactive;
            message2 = ValidationMessages.makeActive
            status = val.status === 'Active' ? 'Inactive' : 'Active'
        }
        else if (typeOfButton === 'active') {
            message = ValidationMessages.pricingActive;
            message2 = ValidationMessages.confirmContinue
            status = val.status === 'Inactive' ? 'Active' : 'Inactive'
        }

        let data = {id:val.id, PricingPlanID: val.pricingPlanID, message, message2, status, val };
        setRowData(data);
        setOpen(true);
        setPopupVisible(false);
    };
    const handleConfirm = async (text, status, val) => {
        if (text === 'confirm') {
            if (status === 'delete') {
                setLoader(true);
                const rowID = val.id;
                try {
                    const response = await fetch(`${hostPath}/api/DeletePricingPlan`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            "x-functions-key": `${hostHeader}`
                        },
                        body: JSON.stringify({ id: rowID, PricingPlanID: val.pricingPlanID  })
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    setOpen(false);
                    //fetchPricingPlans();
                } catch (error) {
                    console.error("Error deleting pricing plan:", error);
                }
                finally{
                    setUpdateData(!updateData);
                }
            }
            else if (status === 'Inactive' || status === 'Active') {
                setLoader(true)
                const pricingplan = {
                    id: val.id,
                    PricingPlanID: val.pricingPlanID,
                    PricingPlanName: val.pricingPlanName,
                    Location: val.location,
                    Occurrence: val.occurrence,
                    Price: val.price,
                    RateUnit: val.rateUnit,
                    TimeRanges: val.timeRanges,
                    IsDefault: val.isDefault,
                    Status:status,
                    //CreatedDate: pricingPlanData.createdDate,
                    //LastUpdatedDate: pricingPlanData.lastUpdatedDate

                }
                try {
                    const response = await fetch(`${hostPath}/api/UpdatePricingPlan`, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                            "x-functions-key": `${hostHeader}`
                        },
                        body: JSON.stringify(pricingplan),
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    setOpen(false);
                }
                catch (error) {
                        console.error("Error saving pricing plan:", error);
                    }
                finally {
                        setLoader(false);
                        setUpdateData(!updateData);
                    }
                    
            }
            
        }
        else if (text === 'cancel') {
            setOpen(false);
        }
    };



return(
<>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}

            <div className="pricing-plan-container">
                <div className="pricing-plan-header">
                    <h3>Pricing Plan Setup</h3>
                    <div className="add-new-pricing" onClick={handleNewPricingPlan}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M7 1V13" stroke="white" stroke-width="2" stroke-linecap="round" />
                            <path d="M1 7L13 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                        </svg>
                        <span> Create New Pricing Plan</span>
                    </div>
                </div>
            </div>
            {isPricingPopupOpen &&
                <div className="popup-overlay">
                    <div className="popup-content">
                        <AddNewPricing setIsPricingPopupOpen={setIsPricingPopupOpen} handleCancelPricing={handleCancelPricing} pricingPlanData={pricingData} setEditPopup={setEditPopup} editPopup={editPopup} onSaveSuccess={handleSaveSuccess} setLoader={setLoader} setLoading={setLoading} loading={loading}/>
                    </div>
                </div>
            }
            <br />
            <Divider
                sx={{
                    height: "2px",
                    backgroundColor: "#8B8B8B",
                    borderRadius: "1px",
                    marginTop: "10px"
                }}
            />
            <br />
            
            <TableContainer component={Paper} sx={{ maxHeight: '505px', overflow: 'auto' }}>
                <Table sx={{ tableLayout: "auto", width: "100%" }} aria-label="pricing table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Pricing Plan</TableCell>
                            <TableCell>Occurrence</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Location</TableCell>
                            <TableCell>Time Ranges</TableCell>
                             <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rowsData.length > 0 ? (
                            rowsData.map((row) => (
                                <TableRow key={row.pricingPlanID}>
                                    <TableCell align="center">{row.pricingPlanName}
                                        {row.isDefault && (
                                            <span className="default-badge">Default</span>
                                        )}
                                    </TableCell>
                                    <TableCell align="center">{row.occurrence.map(dayNum => dayMap[dayNum]).join(', ')}</TableCell>
                                    <TableCell align="center">{'$'+row.price+'/'+row.rateUnit}</TableCell>
                                    <TableCell align="center">{row.location}</TableCell>
                                    <TableCell align="center">{row.timeRanges.map((range, i) => (<div key={i}  className="time-text">{formatTime(range.startTime)} - {formatTime(range.endTime)}</div>))}</TableCell>
                                    <TableCell align="center">
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        {row.status === 'Inactive' ? (
                                            <>
                                            {/* Show "Activate" icon for inactive status */}
                                                <FiEdit3 title="Activate" aria-label="Activate"
                                                    style={{
                                                        width: "38px",
                                                        height: "25px",
                                                        padding: "2px 2px",
                                                        cursor: row.isDefault ? "not-allowed" : "pointer",
                                                        justifyContent: "center",
                                                        color: "green"
                                                        }}
                                                    onClick={row.isDefault ? null : () => handleDelete(row, 'active')}  // Change status to Active
                                                />
                                            </>
                                            ) : (
                                        <>
                                        <FiEdit3 title="Edit" aria-label="Edit" role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleEdit(row)}
                                            style={{
                                                width: "38px",
                                                height: "25px",
                                                padding: "2px 2px",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                marginRight: "5px"
                                            }}
                                          onClick={() => handleEdit(row)}  
                                        />
                                        <FiTrash2 title="Delete" aria-label="Delete" role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleDelete(row, 'trash')}
                                            style={{
                                                width: "38px",
                                                height: "25px",
                                                padding: "2px 2px",
                                                cursor: row.isDefault ? "not-allowed" : "pointer",
                                                justifyContent: "center",
                                                marginRight: "5px",
                                                opacity: row.isDefault ? 0.5 : 1
                                            }}
                                           onClick={row.isDefault ? null :() => handleDelete(row, 'trash')}
                                        />
                                        <FcCancel
                                                title={row.status === 'Active' ? 'Inactive' : 'Disabled'} aria-label="Inactive"
                                                style={{
                                                    width: "38px",
                                                    height: "25px",
                                                    padding: "2px 2px",
                                                    cursor: row.isDefault || row.status !== 'Active' ? "not-allowed" : "pointer",
                                                    justifyContent: "center",
                                                    opacity: row.isDefault || row.status !== 'Active' ? 0.5 : 1, // visually show it's disabled
                                                }}
                                            onClick={row.isDefault || row.status !== 'Active' ? null : () => handleDelete(row, 'cancel')}
                                        />
                                        </>
                                    )}
                                    </div></TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3} align="center">
                                    No Pricing Plans Found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
             <Dialog
                        classes={{ paper: 'custom-paper-class-delete' }}
                        aria-labelledby="customized-dialog-title"
                        dividers
                        open={open}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <DialogTitle dividers sx={{ textAlign: 'start', color: "#000;", fontSize: "24px", fontWeight: "700", padding: "5px 24px " }} id="customized-dialog-title">
                            {rowData?.message}  {/* Display different messages based on the button clicked */}
                        </DialogTitle>
                        <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000;" }}>
                            <Typography gutterBottom>
                                <span>{rowData?.message2}</span>
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'right' }}>
                            <Button
                                className='custom-button-cancel'
                                onClick={() => handleConfirm('cancel')}
                            >
                                Cancel
                            </Button>
                            <Button
                                className='custom-button-delete'
                                onClick={() => handleConfirm('confirm', rowData?.status, rowData?.val)}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>
        </>
);
}
export default Pricing;